import React from 'react';
import PropTypes from 'prop-types';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { ProminentValue } from 'web-ui-components/lib/typography/values';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import config from '../../../config';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';

export const PendingPayment = ({ content, goBack }) => (
  <ApplicationFormShell>
    <div className="col-xs-8 text-center">
      <img
        alt="leaning on a clock"
        src="../../../../images/bow/leaning-on-clock.svg"
      />
      <PageHeading>{content.pendingPaymentTitle}</PageHeading>
    </div>
    <StandardBody>
      <p className="text-center">
        <ProminentValue>{content.pendingPaymentText1}</ProminentValue>
      </p>
    </StandardBody>
    <div className="col-xs-8 text-center">
      <NavigationButton.Primary
        data-test-id="return-to-dashboard-button"
        labelText={content.okGotItButtonLabel}
        onClick={() => {
          goBack();
          AnalyticsUtil.analyticAction(
            config.analytics.analytics_experience_activity,
            config.analytics.analytics_event_method_interacted,
            config.analytics.analytics_action_dispute_pending_payment,
            config.analytics.analytics_action_button_click
          );
        }}
      />
    </div>
  </ApplicationFormShell>
);

PendingPayment.propTypes = {
  content: PropTypes.object,
  goBack: PropTypes.func,
};
